// extracted by mini-css-extract-plugin
export var container = "_el-0";
export var infoIcon = "_el-2";
export var internalLabel = "_el-3";
export var titleRowCol = "_el-1";